import { DefaultTheme } from 'styled-components';

const theme: DefaultTheme = {
  borderRadius: '5px',

  colors: {
    primary: '#FF7D00',
    secondary: '#00AF87',
    ternary: '#000',
    white: '#FFF',
    black: '#000',
    textSecondary: '#777',
    text: '#000',
    textOff: '#D0D0D0',
    strokeA: 'rgba(0, 0, 0, 0.2)',
    strokeB: 'rgba(0, 0, 0, 0.1)',
    label: '#8D8D8D',
    border: '#D6D6D6',
    borderHighlighted: '#000',
    sidebarBg: '#FAF3EB',
    buttonHover: '#454545',
    hoverGray: '#F0F0F0',
    buttonPreset: {
      secondary: {
        bg: '#FAF3EB',
        hover: '#F1E5D5',
        text: '#000',
        textHover: '#000',
      },
      primary: {
        bg: '#FF7D00',
        hover: 'rgb(255, 155, 0)',
        text: '#FFF',
        textHover: '#FFF',
      }
    },
    subtle: '#999',
    error: '#E23009',
    borderError: '#FFA693',
    hover: '#F0F0F0',
  },

  font: {
    light: 'MuseoSans300Light, sans-serif',
    medium: 'MuseoSans500Medium, sans-serif',
    bold: 'MuseoSans700Bold, sans-serif',
  },
  text: {
    small: {
      'font-family': 'MuseoSans500Medium, sans-serif',
      'font-size': '12px'
    },
    normal: {
      'font-family': 'MuseoSans500Medium, sans-serif',
      'font-size': '14px',
    },
    label: {
      'font-family': 'MuseoSans700Bold, sans-serif',
      'font-size': '10px',
    },
    inputValue: {
      'font-family': 'MuseoSans500Medium, sans-serif',
      'font-size': '14px',
    },
    h1: {
      'font-family': 'MuseoSans700Bold, sans-serif',
      'font-size': '24px',
    },
    h2: {
      'font-family': 'MuseoSans700Bold, sans-serif',
      'font-size': '20px',
    },
    headerH2: {
      'font-family': 'MuseoSans500Medium, sans-serif',
      'font-size': '20px',
    },
    headerH3: {
      'font-family': 'MuseoSans300Light, sans-serif',
      'font-size': '18px',
    },
    h3: {
      'font-family': 'MuseoSans500Medium, sans-serif',
      'font-size': '18px',
    },
    h3Strong: {
      'font-family': 'MuseoSans500Medium, sans-serif',
      'font-size': '18px',
      'line-height': '120%',
    },
    tiny: {
      'font-family': 'MuseoSans500Medium, sans-serif',
      'font-size': '11px',
    },
  }

};

export { theme };
